import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import BannerListItemFragment from '../fragments/BannerListItemFragment';

export default gql`
query bannerList($filters: AdminBannerFilters, $sortBy: AdminBannerOrder, $count: Int!, $page: Int) {
    adminBanners(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...BannerListItemFragment
        }
    }
}
${PaginatorInfoFragment}
${BannerListItemFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/bannerList.ts